import React, { useState, useEffect } from 'react';
import MainTable from '../../../components/Table/PaginationTable.js';
import { useNavigate } from 'react-router-dom';
import { ColumnDefShipmentInbox } from '../columns/ColumnDefShipment.js';
import { useSelector, useDispatch } from 'react-redux';
import { fetchShipments, fetchShipmentById } from '../../../redux/shipmentSlice.js';
import DeclineShipmentModalComponent from "../../../components/Modals/DeclineShipmentModalComponent.js";
import AcceptShipmentModalComponent from '../../../components/Modals/AcceptShipmentModalComponent.js';
import { ACTION, SHIPMENT } from '../../../helpers/commonName.js';
import FilterPanelShipment from '../../../components/common components/FilterPanelShipment.js';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import FileOutlineIcon from '@mui/icons-material/Description';
import { Menu, MenuItem ,Button} from '@mui/material';
import DownloadButton from '../../../components/common components/DownloadButton.js';
import {toast} from 'react-hot-toast';

const ShipmentInboxComponent = () => {
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);

  // const { data, loading, error } = useState(''); // Assuming the state shape
  const [actionType, setActionType] = useState(''); 
  const [shipmentId, setShipmentId] = useState(null);
  const tableData = useSelector(state => state.shipment.shipmentData)
  const isLoading = useSelector(state => state.shipment.loading);
  const isError = useSelector(state => state.shipment.error);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false); // State to manage filter panel visibility
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);
  const [isReceiveModalOpen, setIsReceiveModalOpen] = useState(false);
  const [pageNumber, setPageNumber] = useState(1); //  1-based indexing
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState({
    search: '',
    fromDate: '',
    toDate: '',
    shipmentStatus: ''
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const totalRecords = useSelector(state => state.shipment?.totalRecords) || 0;
  const shipment = useSelector(state =>
    state.shipment.shipmentDetails 
        ? state.shipment.shipmentDetails.data
        : []);
  // console.log("totalRecords",totalRecords);

  const navigate = useNavigate();

  useEffect(() => {

    // console.log(`Fetching with pageSize: ${pageSize}, pageNumber: ${pageNumber}`);
    const queryParams = {
      type: 'incoming',
      searchText: filters.search || '',
      fromDate: filters.fromDate || '',
      toDate: filters.toDate || '',
      shipmentStatus: filters.shipmentStatus || '',
      pageSize, // Use state value
      pageNumber, // Use state value
      // companyKeyId
    };
    dispatch(fetchShipments(queryParams));
    // console.log("tableData",tableData)
  }, [dispatch, pageSize, pageNumber]
  ); // Include pageSize and pageNumber in the dependency array

  // useEffect(() => {
  //   shipmentId && dispatch(fetchShipmentById({shipmentId, type:'view'}))
  // }, [dispatch, isReceiveModalOpen])

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const navigateCallback = (shipmentId) => {
    // console.log("shipmentId shipmentId",shipmentId)
    navigate(`/view-details/${shipmentId}`); // Replace with your desired path
  };

  const actionHandler = (shipmentId, action) => {
    setActionType(action);
    setShipmentId(shipmentId);
    // console.log("inside action handler",action,shipmentId,)
    switch(action){
      case ACTION.VIEW: 
      navigate(`/view-details-outbox/${shipmentId}`);
      break;
      case ACTION.RECEIVE: 
        // console.log("INSIDE ACTION HANDLER",shipmentId)
        try{
          dispatch(fetchShipmentById({shipmentId, type:'view'}))
        setIsReceiveModalOpen(true)
        }
        catch(err){
          toast.error("Error occurred:",err)
        }
      break;
      case SHIPMENT.REJECT_SHIPMENT:
        setIsDeclineModalOpen(true);
      break;
    }
    // navigate(`/view-details-outbox/${shipmentId}`); // Replace with your desired path
  };

  const columnDef = ColumnDefShipmentInbox(navigateCallback, actionHandler);

  const onPageIndexChange = (newPageIndex) => {
    // console.log("newPageIndex",newPageIndex);
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    // console.log("newPageSize",newPageSize);
    setPageSize(newPageSize);
    setPageNumber(0); // Reset to the first page when page size changes
  };

   // Function to handle filter action
   const handleFilter = (filters) => {
    // console.log(filters,"filters")
    setFilters(filters);
    const queryParams = {
      type: 'incoming',
      searchText: filters.search || '',
      fromDate: filters.fromDate || '',
      toDate: filters.toDate || '',
      shipmentStatus: filters.shipmentStatus || '',
      pageSize,
      pageNumber,
    };
    dispatch(fetchShipments(queryParams));
  };

  // Function to handle reset action
  const handleReset = () => {
    setFilters({
      search: '',
      fromDate: '',
      toDate: '',
      shipmentStatus: ''
    });
    const queryParams = {
      type: 'incoming',
      searchText: '',
      fromDate: '',
      toDate: '',
      shipmentStatus:  '',
      pageSize,
      pageNumber,
    };
    // Perform reset logic
    dispatch(fetchShipments(queryParams))
    // Perform reset logic
    // console.log('Filter criteria reset');
  };

  const onDeclineModalClose = () => {
    setIsDeclineModalOpen(false)
  }

  const onReceiveModalClose = () => {
    setIsReceiveModalOpen(false)
  }

  // if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error: {isError}</div>;

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <div>
          </div>
          <div>
            {/* <button className="btn btn-primary greeen-btn md_btn">
              <span><i className="mdi mdi-file-document"></i></span>Download Shipment
            </button> */}
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              // variant="contained"
              style={{ backgroundColor: '#6AA13C' }}
              className='btn btn-primary greeen-btn md_btn m-2 h-100'
              startIcon={<FileOutlineIcon />}
            >
              Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>  
              <DownloadButton
              data={tableData}
              filename='Incoming Shipment List.xlsx'
              sheetname='Shipment List'
              forModule='Shipment' />
              </MenuItem>
            </Menu>
            <button className="btn btn-light grey-btn md_btn me-0" onClick={() => setIsFilterPanelOpen(prevState => !prevState)}>
              <span><i className="bi bi-funnel"><FilterAltOutlinedIcon /></i></span> Filters
            </button>
          </div>
        </div>
      </div>
      {isFilterPanelOpen && <FilterPanelShipment className='mb-3' isShipmentStatus={true} onFilter={handleFilter} onReset={handleReset} />}
      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords} // Pass the totalRecords to MainTable
        recordCountText="records found"
      />
      {isDeclineModalOpen &&
       <DeclineShipmentModalComponent
              isOpen={isDeclineModalOpen}
              onClose={onDeclineModalClose}
              id={shipmentId}
              forModule='Shipment'
              action={actionType}
            />
      }
      {isReceiveModalOpen && 
       <AcceptShipmentModalComponent
       isOpen={isReceiveModalOpen}
       onClose={onReceiveModalClose}
       data={shipment}
       filters={filters}
       pageSize={pageSize}
       pageNumber={pageNumber}
     />}
    </>
  )
}

export default ShipmentInboxComponent;
